import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import $ from 'jquery';

/**
 * Generated class for the KomisioningroPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-komisioningro',
  templateUrl: 'komisioningro.html',
})
export class KomisioningroPage {

  nowo: any;
  nomesin: any;

  // data inputan form
  vessel= "";
  pipingsis = "";
  pompa="";
  listrik="";
  daya="";
  watt="";
  volt="";
  feedpump="";
  filpump="";
  dispump="";
  uv="";
  gpm="";
  tipe="";
  sysconduct="";
  systimer="";
  filsand="";
  filcarb="";
  filresin="";
  filpy="";
  pipingins="";
  syslistrik="";
  syspanel="";

  catvessel= "";
  catpipingsis = "";
  catpompa="";
  catlistrik="";
  catdaya="";
  catfeedpump="";
  catfilpump="";
  catdispump="";
  catuv="";
  catsysconduct="";
  catsystimer="";
  catfilsand="";
  catfilcarb="";
  catfilresin="";
  catfilpy="";
  catpipingins="";
  catsyslistrik="";
  catsyspanel="";
  // data inputan form

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
    ) {
      this.nowo = this.navParams.get('nowo');
      this.nowo = this.navParams.get('nomesin');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad KomisioningroPage');
  }

  simpanData(){
    var date = new Date();
    var bln = date.getMonth()+1;
    var tgl = date.getDate();
    var today = "";
    today += date.getFullYear()+'-'+(bln<10 ? '0' : '')+bln+'-'+(tgl<10 ? '0' : '')+tgl;
    var navCtrl = this.navCtrl;
    
    let data = {
      "table": "scan_detail_instalasiro",
      "data": {
        "id_scan_header": "1",
        "tgl_instalasi": today,
        "vessel": this.vessel,
        "catvessel":this.catvessel,
        "pipingsis":this.pipingsis,
        "catpipingsis":this.catpipingsis,
        "pompa":this.pompa,
        "catpompa":this.catpompa,
        "listrik":this.listrik,
        "catlistrik":this.catlistrik,
        "daya":this.daya,
        "catdaya":this.catdaya,
        "watt":this.watt,
        "volt":this.volt,
        "feedpump":this.feedpump,
        "catfeedpump":this.catfeedpump,
        "filpump":this.filpump,
        "catfilpump":this.catfilpump,
        "dispump":this.dispump,
        "catdispump":this.catdispump,
        "uv":this.uv,
        "catuv":this.catuv,
        "gpm":this.gpm,
        "tipe":this.tipe,
        "sysconduct":this.sysconduct,
        "catsysconduct":this.catsysconduct,
        "systimer":this.systimer,
        "catsystimer":this.catsystimer,
        "filsand":this.filsand,
        "catfilsand":this.catfilsand,
        "filcarb":this.filcarb,
        "catfilcarb":this.catfilcarb,
        "filresin":this.filresin,
        "catfilresin":this.catfilresin,
        "filpy":this.filpy,
        "catfilpy":this.catfilpy,
        "pipingins":this.pipingins,
        "catpipingins":this.catpipingins,
        "syslistrik":this.syslistrik,
        "catsyslistrik":this.catsyslistrik,
        "syspanel":this.syspanel,
        "catsyspanel":this.catsyspanel
      }
    }
    $.ajax({
      url: "http://35.240.151.223:43209/newapimobile/send-data",
      data: data,
      type: "post",
      dataType: "json",
      success: function (result) {
        var pesan = result.status;
        var hasil = result.data;
        if (pesan == true) {
          alert('Berhasil Menyimpan data');
          navCtrl.pop();
        }else{
          alert(JSON.stringify(data));
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/komisioningro/komisioningro.ts